import type { ReactElement } from 'react'

import SeriesQ from '@/queries/SeriesQ'
import WorldQ from '@/queries/WorldQ'
import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'

import { SeriesTodoList, type WorldDetailsForTodoList } from '@/components/Worlds/Todos/TodoList'

export default function SeriesHomeTasks({ series }: { series: Query }): ReactElement {
  const user = useUser()
  const world = series.one(SeriesQ.getWorld())
  const worldDetailsForTodoList: WorldDetailsForTodoList = {
    slug: world(WorldQ.slug) ?? '',
    iconUrl: world(WorldQ.icon_url) ?? '',
    title: world(WorldQ.title) ?? '',
    primaryColor: world(WorldQ.primary_color) ?? '',
  }
  const isUserHost = series(SeriesQ.isHost({ userId: user.id })) ?? false

  return (
    <SeriesTodoList
      world={worldDetailsForTodoList}
      headingSize="xl"
      maxToShow={2}
      includeWorldInfo
      excludeTargetLevel={isUserHost ? 'member' : 'tutor'}
    />
  )
}
